// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__34Er2","header":"ClearentDisclaimer_header__3oDmM","inner":"ClearentDisclaimer_inner__2tjcG"};